module.exports = __webpack_public_path__ + "media/icons/mp4-41db90a8.png";